import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  display: ['none', null, 'block'],
  flex: [null, null, 1],
  pt: [null, null, '14px'],
};

export const TextItem: CSSObject = {
  color: 'white',
  textAlign: 'center',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '400',

  span: { color: 'beta.500', fontWeight: 'bold' },
};

export const LinkItem: CSSObject = {};
